import type { SvgIconProps } from '@mui/material/SvgIcon';

import { memo, forwardRef } from 'react';

import SvgIcon from '@mui/material/SvgIcon';

// ----------------------------------------------------------------------

const UserIcon = forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => {
  const { sx, ...other } = props;

  return (
    <SvgIcon
      ref={ref}
      fill="none"
      viewBox="0 0 148 148"
      xmlns="http://www.w3.org/2000/svg"
      sx={[
        (theme) => ({
          width: 148,
          flexShrink: 0,
          height: 'auto',
        }),
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
      {...other}
    >
      <g opacity={0.48}>
        <path
          fill="url(#a)"
          d="M28.058 49.861c0 12.623 10.329 22.739 23.218 22.739 12.885 0 23.22-10.116 23.22-22.739 0-12.622-10.335-22.738-23.22-22.738-12.89 0-23.218 10.116-23.218 22.738"
        />
        <path
          fill="url(#b)"
          d="M86.367 98.345c0-11.685-16.164-14.608-35.09-14.608-19.028 0-35.09 3.024-35.09 14.718 0 11.685 16.165 14.608 35.09 14.608 19.028 0 35.09-3.024 35.09-14.718"
        />
      </g>
      <path
        fill="url(#c)"
        d="M55.345 48.32c0 16.554 13.546 29.82 30.45 29.82 16.897 0 30.45-13.266 30.45-29.82S102.692 18.5 85.795 18.5c-16.904 0-30.45 13.266-30.45 29.82"
      />
      <path
        fill="url(#d)"
        d="M131.812 111.906c0-15.324-21.198-19.158-46.018-19.158-24.954 0-46.018 3.966-46.018 19.302 0 15.324 21.198 19.158 46.018 19.158 24.954 0 46.018-3.966 46.018-19.302"
      />
      <g opacity={0.48}>
        <path
          fill="url(#e)"
          d="M55.345 48.32c0 16.554 13.546 29.82 30.45 29.82 16.897 0 30.45-13.266 30.45-29.82S102.692 18.5 85.795 18.5c-16.904 0-30.45 13.266-30.45 29.82"
        />
        <path
          fill="url(#f)"
          d="M131.812 111.906c0-15.324-21.198-19.158-46.018-19.158-24.954 0-46.018 3.966-46.018 19.302 0 15.324 21.198 19.158 46.018 19.158 24.954 0 46.018-3.966 46.018-19.302"
        />
      </g>
      <path
        stroke="#000"
        d="M85.794 93.248c12.4 0 23.835.96 32.155 3.806 4.157 1.422 7.5 3.303 9.8 5.737 2.288 2.423 3.563 5.413 3.563 9.115 0 3.706-1.267 6.707-3.546 9.144-2.289 2.448-5.62 4.347-9.768 5.786-8.303 2.88-19.738 3.872-32.204 3.872-12.398 0-23.834-.96-32.155-3.806-4.157-1.422-7.5-3.303-9.8-5.737-2.288-2.422-3.563-5.413-3.563-9.115 0-3.706 1.267-6.708 3.546-9.145 2.29-2.448 5.62-4.346 9.77-5.785 8.302-2.88 19.737-3.872 32.202-3.872Zm0-74.248c16.632 0 29.951 13.052 29.951 29.32-.001 16.268-13.319 29.32-29.95 29.32-16.638 0-29.95-13.052-29.95-29.32S69.156 19 85.794 19Z"
        opacity={0.04}
      />
      <defs>
        <linearGradient
          id="a"
          x1={16.188}
          x2={100.394}
          y1={27.123}
          y2={95.886}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#BBF66D" />
          <stop offset={1} stopColor="#97E038" />
        </linearGradient>
        <linearGradient
          id="b"
          x1={16.188}
          x2={100.394}
          y1={27.123}
          y2={95.886}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#BBF66D" />
          <stop offset={1} stopColor="#97E038" />
        </linearGradient>
        <linearGradient
          id="c"
          x1={39.776}
          x2={150.209}
          y1={18.5}
          y2={108.679}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#BBF66D" />
          <stop offset={1} stopColor="#97E038" />
        </linearGradient>
        <linearGradient
          id="d"
          x1={39.776}
          x2={150.209}
          y1={18.5}
          y2={108.679}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#BBF66D" />
          <stop offset={1} stopColor="#97E038" />
        </linearGradient>
        <linearGradient
          id="e"
          x1={39.776}
          x2={150.209}
          y1={18.5}
          y2={108.679}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#97E038" />
          <stop offset={1} stopColor="#4A8201" />
        </linearGradient>
        <linearGradient
          id="f"
          x1={39.776}
          x2={150.209}
          y1={18.5}
          y2={108.679}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#97E038" />
          <stop offset={1} stopColor="#4A8201" />
        </linearGradient>
      </defs>
    </SvgIcon>
  );
});

export default memo(UserIcon);